module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('main', [_c('h1', {
    staticClass: "f2 lh-copy pt3"
  }, [_vm._v(_vm._s(_vm.$t('titles.addclaims')))]), _vm._v(" "), (!_vm.userHasAccess) ? _c('div', [(_vm.user.membership_status === 'CANCELED') ? _c('ak-alert', {
    attrs: {
      "color": "red"
    }
  }, [_c('span', [_vm._v("Your coverage plan was cancelled. If you'd like to re-enable your coverage, ")]), _vm._v(" "), _c('a', {
    staticClass: "color-theme",
    attrs: {
      "href": "mailto:billing@getakko.com?Subject=Re-enable my plan"
    }
  }, [_vm._v("please contact our billing team.")])]) : _vm._e(), _vm._v(" "), (_vm.user.membership_status === 'UNPAID') ? _c('ak-alert', {
    attrs: {
      "color": "red"
    }
  }, [_c('span', [_vm._v("Your coverage plan is currently unpaid. Please proceed to "), _c('router-link', {
    staticClass: "color-theme",
    attrs: {
      "to": "/account/dashboard"
    }
  }, [_vm._v("Account Settings")]), _vm._v(" to resolve or ")], 1), _vm._v(" "), _c('a', {
    staticClass: "color-theme",
    attrs: {
      "href": "mailto:billing@getakko.com?Subject=Re-enable my plan"
    }
  }, [_vm._v("contact our billing team")]), _vm._v(".\n    ")]) : _vm._e(), _vm._v(" "), (_vm.user.membership_status === 'PAST_DUE') ? _c('ak-alert', {
    attrs: {
      "color": "red"
    }
  }, [_c('span', [_vm._v("Your coverage plan is currently past due. Please proceed to "), _c('router-link', {
    staticClass: "color-theme",
    attrs: {
      "to": "/account/dashboard"
    }
  }, [_vm._v("Account Settings")]), _vm._v(" to resolve or ")], 1), _vm._v(" "), _c('a', {
    staticClass: "color-theme",
    attrs: {
      "href": "mailto:billing@getakko.com?Subject=Re-enable my plan"
    }
  }, [_vm._v("contact our billing team")]), _vm._v(".\n    ")]) : _vm._e(), _vm._v(" "), (_vm.user.membership_status === 'BANNED') ? _c('ak-alert', {
    attrs: {
      "color": "red"
    }
  }, [_c('span', [_vm._v("Your account has been banned. If you think this was done in error, ")]), _vm._v(" "), _c('a', {
    staticClass: "color-theme",
    attrs: {
      "href": "mailto:billing@getakko.com?Subject=Inquiry Regarding Banned Account"
    }
  }, [_vm._v("please contact our billing team.")])]) : _vm._e(), _vm._v(" "), (_vm.user.membership_status === 'INACTIVE') ? _c('ak-alert', {
    attrs: {
      "color": "red"
    }
  }, [_c('span', [_vm._v("Your coverage plan was cancelled. If you'd like to re-enable your coverage, ")]), _vm._v(" "), _c('a', {
    staticClass: "color-theme",
    attrs: {
      "href": "mailto:billing@getakko.com?Subject=Re-enable my plan"
    }
  }, [_vm._v("please contact our billing team.")])]) : _vm._e(), _vm._v(" "), (_vm.user.membership_status === 'INVALID_USER') ? _c('ak-alert', {
    attrs: {
      "color": "red"
    }
  }, [_c('span', [_vm._v("Your account has been marked as invalid by our system due to unpaid premiums or other account issues. If you think this was done in error, ")]), _vm._v(" "), _c('a', {
    staticClass: "color-theme",
    attrs: {
      "href": "mailto:billing@getakko.com?Subject=Re-enable my plan"
    }
  }, [_vm._v("please contact our billing team.")])]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "grid-custom-ns"
  }, [_c('div', {
    staticClass: "mt4"
  }, [_vm._m(0), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.loss_date),
      expression: "loss_date"
    }],
    staticClass: "input-reset ba b--black-20 pa2 mb2 db w-100 br1",
    attrs: {
      "id": "loss_date",
      "type": "date",
      "max": _vm.today_string
    },
    domProps: {
      "value": (_vm.loss_date)
    },
    on: {
      "focus": function($event) {
        return _vm.toggleKeyboard(true)
      },
      "blur": function($event) {
        return _vm.toggleKeyboard(false)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.loss_date = $event.target.value
      }
    }
  })]), _vm._v(" "), (!_vm.featureFlagMultiLossTypeActive) ? _c('div', {
    staticClass: "mv4"
  }, [_vm._m(1), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.loss_type),
      expression: "loss_type"
    }],
    staticClass: "b--black-20 pa2 mb2 db w-100 br1",
    attrs: {
      "id": "loss_type"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.loss_type = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Select a type of loss")]), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._m(4)])]) : _vm._e()]), _vm._v(" "), _c('div', {
    class: _vm.featureFlagMultiLossTypeActive ? '' : 'grid-half'
  }, [_c('div', {
    staticClass: "mb4"
  }, [_vm._m(5), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.description),
      expression: "description"
    }],
    staticClass: "input-reset ba b--black-20 pa2 mb2 db w-100 br1",
    attrs: {
      "id": "description",
      "maxlength": "1000",
      "rows": "6"
    },
    domProps: {
      "value": (_vm.description)
    },
    on: {
      "focus": function($event) {
        return _vm.toggleKeyboard(true)
      },
      "blur": function($event) {
        return _vm.toggleKeyboard(false)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.description = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "fr f6 mt1 silver"
  }, [_vm._v(_vm._s(_vm.desc_count) + "/1000 characters")])])]), _vm._v(" "), _c('div', [_vm._m(6), _vm._v(" "), (_vm.userXPIsWeb) ? _c('div', {
    staticClass: "f6 mb2 lh-copy inter"
  }, [_vm._v("\n      Not seeing your item? Please\n      "), _c('router-link', {
    staticClass: "color-theme",
    attrs: {
      "to": "/add-device-category"
    }
  }, [_vm._v("add it here")]), _vm._v("\n      then return to file a claim.\n    ")], 1) : _vm._e(), _vm._v(" "), (_vm.registered_devices.length > 0) ? _c('div', {
    class: _vm.featureFlagMultiLossTypeActive ? 'devices-affected' : 'flex flex-wrap pb3'
  }, _vm._l((_vm.registered_devices), function(device, index) {
    return _c('div', {
      key: index,
      staticClass: "mr2 mb3"
    }, [(!_vm.featureFlagMultiLossTypeActive) ? _c('div', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.devices),
        expression: "devices"
      }],
      staticClass: "dn",
      attrs: {
        "type": "checkbox",
        "id": device.id,
        "disabled": device.has_active_claims
      },
      domProps: {
        "value": device.id,
        "checked": Array.isArray(_vm.devices) ? _vm._i(_vm.devices, device.id) > -1 : (_vm.devices)
      },
      on: {
        "change": function($event) {
          var $$a = _vm.devices,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = device.id,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.devices = $$a.concat([$$v]))
            } else {
              $$i > -1 && (_vm.devices = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.devices = $$c
          }
        }
      }
    }), _vm._v(" "), _c('label', {
      staticClass: "db pv2 ph3 f6 tc b ba br-pill b-theme bg-white color-theme pointer inter",
      attrs: {
        "for": device.id
      }
    }, [_vm._v(_vm._s(device.nickname))])]) : _vm._e(), _vm._v(" "), (_vm.featureFlagMultiLossTypeActive) ? _c('div', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.devices),
        expression: "devices"
      }],
      staticClass: "dn",
      attrs: {
        "type": "checkbox",
        "id": device.id,
        "disabled": device.has_active_claims
      },
      domProps: {
        "value": device.id,
        "checked": Array.isArray(_vm.devices) ? _vm._i(_vm.devices, device.id) > -1 : (_vm.devices)
      },
      on: {
        "change": function($event) {
          var $$a = _vm.devices,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = device.id,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.devices = $$a.concat([$$v]))
            } else {
              $$i > -1 && (_vm.devices = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.devices = $$c
          }
        }
      }
    }), _vm._v(" "), _c('label', {
      staticClass: "db mb2 pv2 ph3 f6 tc ba br-pill b-theme bg-white color-theme pointer",
      attrs: {
        "for": device.id
      }
    }, [_vm._v(_vm._s(device.nickname))]), _vm._v(" "), (_vm.isSelected(device.id)) ? _c('div', [_c('div', {
      staticClass: "mb2"
    }, [_vm._m(7, true), _vm._v(" "), _c('Multiselect', {
      attrs: {
        "placeholder": "Select loss types",
        "label": "name",
        "track-by": "name",
        "group-label": "category",
        "group-values": "typeLoss",
        "searchable": false,
        "group-select": false,
        "options": _vm.lossTypesOptions,
        "multiple": true,
        "taggable": true
      },
      model: {
        value: (_vm.lossTypeValues[device.id]),
        callback: function($$v) {
          _vm.$set(_vm.lossTypeValues, device.id, $$v)
        },
        expression: "lossTypeValues[device.id]"
      }
    })], 1), _vm._v(" "), (_vm.displayItemOperability(device.id)) ? _c('div', {
      staticClass: "mb2"
    }, [_vm._m(8, true), _vm._v(" "), _c('Multiselect', {
      attrs: {
        "placeholder": "Select item operability",
        "label": "description",
        "track-by": "id",
        "searchable": false,
        "options": _vm.itemOperabilityOptions
      },
      model: {
        value: (_vm.itemOperabilityValues[device.id]),
        callback: function($$v) {
          _vm.$set(_vm.itemOperabilityValues, device.id, $$v)
        },
        expression: "itemOperabilityValues[device.id]"
      }
    })], 1) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "mb2"
    }, [_vm._m(9, true), _vm._v(" "), _c('div', {
      staticClass: "f6 mb2"
    }, [_vm._v("\n                Did this item have any damage prior to this incident? If so, please explain.\n              ")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.previousDamages[device.id]),
        expression: "previousDamages[device.id]"
      }],
      staticClass: "input-reset ba b--black-10 pa2 mb2 db w-100 br1",
      attrs: {
        "id": "known_damage_",
        "maxlength": "1000",
        "rows": "6"
      },
      domProps: {
        "value": (_vm.previousDamages[device.id])
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.previousDamages, device.id, $event.target.value)
        }
      }
    })])]) : _vm._e()]) : _vm._e()])
  }), 0) : _vm._e(), _vm._v(" "), (_vm.registered_devices.length == 0) ? _c('ak-alert', {
    attrs: {
      "color": "red"
    }
  }, [_c('span', [_vm._v("You haven't added any items to your account.")]), _vm._v(" "), _c('router-link', {
    staticClass: "color-theme",
    attrs: {
      "to": "/add-device-category"
    }
  }, [_c('u', [_vm._v("Add your items here.")])])], 1) : _vm._e()], 1), _vm._v(" "), _c('div', {
    class: _vm.featureFlagMultiLossTypeActive ? '' : 'grid-half'
  }, [(!_vm.featureFlagMultiLossTypeActive) ? _c('div', {
    staticClass: "mt4"
  }, [_vm._m(10), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.known_damage),
      expression: "known_damage"
    }],
    staticClass: "input-reset ba b--black-20 pa2 mb2 db w-100 br1",
    attrs: {
      "id": "known_damage",
      "maxlength": "1000",
      "rows": "6"
    },
    domProps: {
      "value": (_vm.known_damage)
    },
    on: {
      "focus": function($event) {
        return _vm.toggleKeyboard(true)
      },
      "blur": function($event) {
        return _vm.toggleKeyboard(false)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.known_damage = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "fr f6 mt1 silver"
  }, [_vm._v(_vm._s(_vm.dmg_count) + "/1000 characters")])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "mt3"
  }, [_c('br'), _vm._v(" "), _vm._m(11), _vm._v(" "), _c('div', {
    staticClass: "f6 mb2 lh-copy inter"
  }, [_vm._v("Provide clear images of damage, evidence, and/or a copy of your police report.")]), _vm._v(" "), _c('ak-img-input', {
    attrs: {
      "id": "images",
      "uploadTypes": _vm.acceptedUploadTypes,
      "description": _vm.uploadTypeDescription
    },
    on: {
      "filesUpdated": function (payload) { return _vm.images = payload; }
    }
  }, [_c('div', {
    staticClass: "db f6 gray pt2"
  }, [_vm._v("\n          " + _vm._s(_vm.uploadTypeDescription) + "\n          "), _c('br'), _vm._v(" "), _c('a', {
    attrs: {
      "href": _vm.fileFormatConversionUrl,
      "target": "_blank"
    }
  }, [_vm._v(" " + _vm._s(_vm.heicfConversionDescription) + " ")])])])], 1), _vm._v(" "), (_vm.requiresDeviceVerification) ? _c('div', {
    staticClass: "mt3"
  }, [_c('br'), _vm._v(" "), _c('label', {
    staticClass: "db fw5 f5 mb2 cera-round-pro-medium"
  }, [_vm._v(" " + _vm._s(this.requiresAboutPage ? this.aboutPageTitle : this.phoneUniqueIdTitle) + " "), _c('span', {
    staticClass: "color-theme f5"
  }, [_vm._v(" *")])]), _vm._v(" "), _c('div', {
    staticClass: "f6 mb2 lh-copy inter"
  }, [_vm._v("\n        " + _vm._s(_vm.requiresAboutPage ? _vm.aboutPageDescription : _vm.phoneUniqueIdDescription) + "\n        "), _c('a', {
    attrs: {
      "href": _vm.requiresAboutPage ? _vm.aboutPageExampleUrl : _vm.phoneUniqueIdExampleUrl,
      "target": "_blank"
    }
  }, [_vm._v("Click here to see examples.")])]), _vm._v(" "), _c('div', {
    staticClass: "mt2"
  }, [_c('label', {
    staticClass: "dib fw5 f6 mb2 inter i",
    attrs: {
      "for": "hasDeviceVerificationException"
    }
  }, [_c('br'), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.hasDeviceVerificationException),
      expression: "hasDeviceVerificationException"
    }],
    staticClass: "normal",
    attrs: {
      "type": "checkbox",
      "id": "hasDeviceVerificationException"
    },
    domProps: {
      "checked": Array.isArray(_vm.hasDeviceVerificationException) ? _vm._i(_vm.hasDeviceVerificationException, null) > -1 : (_vm.hasDeviceVerificationException)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.hasDeviceVerificationException,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.hasDeviceVerificationException = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.hasDeviceVerificationException = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.hasDeviceVerificationException = $$c
        }
      }
    }
  }), _vm._v("\n          I am unable to turn on my damaged phone or use the screen.\n        ")])]), _vm._v(" "), _c('ak-img-input', {
    attrs: {
      "id": "imagesDeviceVerification",
      "uploadTypes": _vm.acceptedUploadTypes,
      "description": _vm.uploadTypeDescription
    },
    on: {
      "filesUpdated": function (payload) { return _vm.imagesDeviceVerification = payload; }
    }
  }, [_c('div', {
    staticClass: "db f6 gray pt2"
  }, [_vm._v("\n          " + _vm._s(_vm.uploadTypeDescription) + "\n          "), _c('br'), _vm._v(" "), _c('a', {
    attrs: {
      "href": _vm.fileFormatConversionUrl,
      "target": "_blank"
    }
  }, [_vm._v(" " + _vm._s(_vm.heicfConversionDescription) + " ")])])])], 1) : _vm._e(), _vm._v(" "), _vm._m(12), _vm._v(" "), _c('div', {
    staticClass: "grid-half"
  }, [_c('fieldset', {
    staticClass: "input-reset bn pa0 ma0"
  }, [_c('div', {
    staticClass: "flex justify-around w-50"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.payoutMethod),
      expression: "payoutMethod"
    }],
    staticClass: "dn",
    attrs: {
      "id": "payoutpaypal",
      "type": "radio",
      "name": "payoutmethod"
    },
    domProps: {
      "value": _vm.payoutMethods.PAYPAL,
      "checked": _vm._q(_vm.payoutMethod, _vm.payoutMethods.PAYPAL)
    },
    on: {
      "change": function($event) {
        _vm.payoutMethod = _vm.payoutMethods.PAYPAL
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "flex-grow pv2 tc fw5 ba br1 br--left b--silver silver bg-white pointer",
    attrs: {
      "tabindex": "0",
      "for": "payoutpaypal"
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        _vm.payoutMethod = _vm.payoutMethods.PAYPAL
      }
    }
  }, [_vm._v("PayPal")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.payoutMethod),
      expression: "payoutMethod"
    }],
    staticClass: "dn",
    attrs: {
      "id": "payoutvenmo",
      "type": "radio",
      "name": "payoutmethod"
    },
    domProps: {
      "value": _vm.payoutMethods.VENMO,
      "checked": _vm._q(_vm.payoutMethod, _vm.payoutMethods.VENMO)
    },
    on: {
      "change": function($event) {
        _vm.payoutMethod = _vm.payoutMethods.VENMO
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "flex-grow pv2 tc fw5 ba bl-0 br1 br--right b--silver silver bg-white pointer",
    attrs: {
      "tabindex": "0",
      "for": "payoutvenmo"
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        _vm.payoutMethod = _vm.payoutMethods.VENMO
      }
    }
  }, [_vm._v("Venmo")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.payoutMethod),
      expression: "payoutMethod"
    }],
    staticClass: "dn",
    attrs: {
      "id": "payoutskip",
      "type": "radio",
      "name": "payoutmethod"
    },
    domProps: {
      "value": _vm.payoutMethods.WITHOUT_PAYOUT_METHOD,
      "checked": _vm._q(_vm.payoutMethod, _vm.payoutMethods.WITHOUT_PAYOUT_METHOD)
    },
    on: {
      "change": function($event) {
        _vm.payoutMethod = _vm.payoutMethods.WITHOUT_PAYOUT_METHOD
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "flex-grow pv2 tc fw5 ba bl-0 br1 br--right b--silver silver bg-white pointer",
    attrs: {
      "tabindex": "0",
      "for": "payoutskip"
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        _vm.payoutMethod = _vm.payoutMethods.WITHOUT_PAYOUT_METHOD
      }
    }
  }, [_vm._v("Skip")])])])]), _vm._v(" "), (_vm.payoutMethod == _vm.payoutMethods.PAYPAL) ? _c('div', {
    staticClass: "grid-half"
  }, [_c('div', [_c('div', {
    staticClass: "mt2"
  }, [_c('label', {
    staticClass: "f6 b db mb2",
    attrs: {
      "for": "paypalemail"
    }
  }, [_vm._v("PayPal Email")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.paypalemail),
      expression: "paypalemail"
    }],
    staticClass: "input-email ba b--black-20 pa2 mb2 db w-100 br1 w-100-ns",
    attrs: {
      "id": "paypalemail",
      "name": "paypalemail",
      "type": "email",
      "autocomplete": "paypalemail"
    },
    domProps: {
      "value": (_vm.paypalemail)
    },
    on: {
      "focus": function($event) {
        return _vm.toggleKeyboard(true)
      },
      "blur": function($event) {
        return _vm.toggleKeyboard(false)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.paypalemail = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.emailValidationMessages.error) ? _c('div', {
    staticClass: "red f7 mt2",
    attrs: {
      "id": "emailvalidationmessage"
    }
  }, [_vm._v(_vm._s(_vm.emailValidationMessages.error))]) : _vm._e()])])]) : _vm._e(), _vm._v(" "), (_vm.payoutMethod == _vm.payoutMethods.VENMO) ? _c('div', {
    staticClass: "grid-half"
  }, [_c('div', {
    staticClass: "mt3"
  }, [_c('div', {
    staticClass: "mt2"
  }, [_c('label', {
    staticClass: "f6 b db mb2",
    attrs: {
      "for": "venmoPhone"
    }
  }, [_vm._v("Venmo Phone")]), _vm._v(" "), _c('label', {
    staticClass: "f6 b db mb2",
    attrs: {
      "for": "venmoPhone"
    }
  }, [_vm._v("(Verify your phone number)")]), _vm._v(" "), _c('InputMask', {
    staticClass: "input-reset ba b--black-20 pa2 mb2 db w-100 br1",
    attrs: {
      "id": "venmoPhone",
      "name": "venmoPhone",
      "type": "tel",
      "mask": "(999) 999-9999",
      "unmask": true
    },
    on: {
      "focus": function($event) {
        return _vm.toggleKeyboard(true)
      },
      "blur": function($event) {
        return _vm.toggleKeyboard(false)
      }
    },
    model: {
      value: (_vm.venmoPhone),
      callback: function($$v) {
        _vm.venmoPhone = $$v
      },
      expression: "venmoPhone"
    }
  }), _vm._v(" "), (_vm.venmoPhoneValidationMessages.error) ? _c('div', {
    staticClass: "red f7 mt2",
    attrs: {
      "id": "venmoPhonevalidationmessage"
    }
  }, [_vm._v(_vm._s(_vm.venmoPhoneValidationMessages.error))]) : _vm._e()], 1)])]) : _vm._e(), _vm._v(" "), (_vm.payoutMethod == _vm.payoutMethods.WITHOUT_PAYOUT_METHOD) ? _c('div', [_vm._m(13)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "mt4",
    class: [!_vm.userHasAccess ? 'pb4' : '']
  }, [_c('h3', {
    staticClass: "db fw5 f6 mb1 inter"
  }, [_vm._v("DISCLAIMER:")]), _vm._v(" "), _c('p', {
    staticClass: "dark-gray i f6 inter"
  }, [_vm._v("\n      We must advise you that any person who knowingly, and with intent to commit fraud, files a statement of claim containing any materially false information,\n      or conceals for the purpose of misleading information concerning any fact thereto, commits a fraudulent act, which is a crime and may be prosecuted to the\n      full extent of the law. By signing, I agree that the statements above are true and correct to the best of my knowledge and cannot be changed once submitted to the company.\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "mt2"
  }, [_c('label', {
    staticClass: "dib fw5 f6 mb2 inter",
    attrs: {
      "for": "disclaimer"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.disclaimer),
      expression: "disclaimer"
    }],
    staticClass: "normal",
    attrs: {
      "type": "checkbox",
      "id": "disclaimer"
    },
    domProps: {
      "checked": Array.isArray(_vm.disclaimer) ? _vm._i(_vm.disclaimer, null) > -1 : (_vm.disclaimer)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.disclaimer,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.disclaimer = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.disclaimer = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.disclaimer = $$c
        }
      }
    }
  }), _vm._v("\n        I agree and am filing this claim with full knowledge of my coverage benefits as outlined in the user agreement and terms and conditions.\n      ")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showAccept),
      expression: "showAccept"
    }],
    staticClass: "mt2"
  }, [_c('p', {
    staticClass: "dark-gray f6 inter"
  }, [_vm._v("\n        Please note, your phone will be reported as stolen and unusable once this claim is submitted.\n      ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.acceptChkbx),
      expression: "acceptChkbx"
    }],
    staticClass: "normal",
    attrs: {
      "id": "acceptChkbx",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.acceptChkbx) ? _vm._i(_vm.acceptChkbx, null) > -1 : (_vm.acceptChkbx)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.acceptChkbx,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.acceptChkbx = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.acceptChkbx = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.acceptChkbx = $$c
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "dib fw5 f6 mb2 inter",
    attrs: {
      "for": "acceptChkbx"
    }
  }, [_vm._v("I Accept")])]), _vm._v(" "), _c('div', {
    staticClass: "mv4"
  }, [_c('label', {
    staticClass: "db fw5 f6 mb2",
    attrs: {
      "for": "sig"
    }
  }, [_vm._v("Please type your full name as a digital signature")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sig),
      expression: "sig"
    }],
    staticClass: "input-reset ba b--black-20 pa2 mb2 db w-100 br1 w-50-ns",
    attrs: {
      "id": "sig",
      "type": "text",
      "disabled": !_vm.disclaimer
    },
    domProps: {
      "value": (_vm.sig)
    },
    on: {
      "focus": function($event) {
        return _vm.toggleKeyboard(true)
      },
      "blur": function($event) {
        return _vm.toggleKeyboard(false)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.sig = $event.target.value
      }
    }
  })])]), _vm._v(" "), (_vm.userHasAccess) ? _c('div', {
    staticClass: "mt4 mb5 mw5-ns"
  }, [_c('ak-button', {
    attrs: {
      "block": "",
      "disabled": !_vm.formComplete || _vm.loading,
      "primary": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.fileClaim.apply(null, arguments)
      }
    }
  }, [_vm._v("File Claim")])], 1) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "db fw5 f5 mb2 cera-round-pro-medium",
    attrs: {
      "for": "loss_date"
    }
  }, [_vm._v("Date of Loss"), _c('span', {
    staticClass: "color-theme f5"
  }, [_vm._v(" *")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "db fw5 f6 mb2",
    attrs: {
      "for": "loss_type"
    }
  }, [_vm._v("Type of loss"), _c('span', {
    staticClass: "color-theme f5"
  }, [_vm._v(" *")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('optgroup', {
    attrs: {
      "label": "Accidental Damage"
    }
  }, [_c('option', {
    attrs: {
      "value": "Cracked Screen"
    }
  }, [_vm._v("Cracked Screen")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Cracked Back"
    }
  }, [_vm._v("Cracked Back")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Cracked Camera"
    }
  }, [_vm._v("Cracked Camera")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Liquid Damage"
    }
  }, [_vm._v("Liquid Damage")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Accidental Damage - Other"
    }
  }, [_vm._v("Other")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('optgroup', {
    attrs: {
      "label": "Malfunctions"
    }
  }, [_c('option', {
    attrs: {
      "value": "Screen"
    }
  }, [_vm._v("Screen")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Camera"
    }
  }, [_vm._v("Camera")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Charging Port"
    }
  }, [_vm._v("Charging Port")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Battery"
    }
  }, [_vm._v("Battery")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Malfunctions - Other"
    }
  }, [_vm._v("Other")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('optgroup', {
    attrs: {
      "label": "Theft and Vandalism"
    }
  }, [_c('option', {
    attrs: {
      "value": "Theft"
    }
  }, [_vm._v("Theft")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Theft from Unattended Vehicle"
    }
  }, [_vm._v("Theft from Unattended Vehicle")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Vandalism"
    }
  }, [_vm._v("Vandalism")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Theft and Vandalism - Other"
    }
  }, [_vm._v("Other")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "db fw5 f5 mb2 cera-round-pro-medium",
    attrs: {
      "for": "description"
    }
  }, [_vm._v("Description of Incident:"), _c('span', {
    staticClass: "color-theme f5"
  }, [_vm._v(" *")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "db fw5 f5 mb2 cera-round-pro-medium"
  }, [_vm._v("Affected Items:"), _c('span', {
    staticClass: "color-theme f5"
  }, [_vm._v(" *")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "db fw5 f6 mb2 cera-round-pro-medium",
    attrs: {
      "for": "loss_type"
    }
  }, [_vm._v("Type of Loss"), _c('span', {
    staticClass: "color-theme f5"
  }, [_vm._v(" *")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "db fw5 f6 mb2 cera-round-pro-medium",
    attrs: {
      "for": "item_operability"
    }
  }, [_vm._v("Item Operability"), _c('span', {
    staticClass: "color-theme f5"
  }, [_vm._v(" *")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "db fw5 f6 mb2 cera-round-pro-medium",
    attrs: {
      "for": "known_damage_"
    }
  }, [_vm._v("Previous Known Damage:"), _c('span', {
    staticClass: "color-theme f5"
  }, [_vm._v(" *")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "db fw5 f6 mb2",
    attrs: {
      "for": "known_damage"
    }
  }, [_vm._v("Previous known damage:"), _c('span', {
    staticClass: "color-theme f5"
  }, [_vm._v(" *")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "db fw5 f5 mb2 cera-round-pro-medium"
  }, [_vm._v("Upload Proof:"), _c('span', {
    staticClass: "color-theme f5"
  }, [_vm._v(" *")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mt3"
  }, [_c('div', {
    staticClass: "mt2"
  }, [_c('label', {
    staticClass: "db fw5 f5 mb2 cera-round-pro-medium"
  }, [_vm._v("Select Payout Method"), _c('span', {
    staticClass: "color-theme f5"
  }, [_vm._v(" *")])]), _vm._v(" "), _c('div', {
    staticClass: "f6 mb2"
  }, [_vm._v("Selecting a payout method now ensures the fastest possible transfer once your claim is approved for repair or replacement")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mt3"
  }, [_c('div', {
    staticClass: "mt2"
  }, [_c('label', {
    staticClass: "f6 b db mb2"
  }, [_vm._v("Our support team will be happy to coordinate an alternative payout method with you upon resolution.")])])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-45464a62", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-45464a62","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/AddClaim.vue
// module id = 1540
// module chunks = 0